import screens from '../navigation/screens';
import appActions, { appActionScreenMap } from '../constants/appActions';

export const getPersonalRewardNavigationScreen = (action, options = {}) => {
  return action === appActions.OPEN_ADD_EMAIL && options.isUnverifiedEmail
    ? screens.VerifyEmail
    : appActionScreenMap[action];
};
